import { render, staticRenderFns } from "./bkCfg.vue?vue&type=template&id=2d0442c6"
import script from "./bkCfg.vue?vue&type=script&lang=js"
export * from "./bkCfg.vue?vue&type=script&lang=js"
import style0 from "./bkCfg.vue?vue&type=style&index=0&id=2d0442c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports